import React from 'react';
import { decodePolyline } from '../Util'
import * as d3 from "d3";

import { VectorTile } from '@mapbox/vector-tile';
import Protobuf from 'pbf';

import GlobalMercator from '../GlobalMercator';
import * as d3Tile from "d3-tile";


class Basemap extends React.Component {

	componentDidMount() {
		console.log("Did mount");
		d3.select(this.container).append('g').attr('id', 'water');
		d3.select(this.container).append('g').attr('id', 'roads');
		d3.select(this.container).append('g').attr('id', 'buildings');


		if(this.props.activities.length>0){
			this.display(this.props.activities);
		}

	}

	display(activities) {

		//Clear content
		d3.select('#roads').text('');
		d3.select('#buildings').text('');
		d3.select('#water').text('');
		d3.select('#landuse').text('');

		var featureCollection = {
			type: "FeatureCollection",
			features: []
		}

		console.log(activities);

		activities.forEach(function(activity){
			if(activity.map.summary_polyline){
				var feature = {
					type: "Feature",
					properties: {},
					geometry: {
						type: "LineString",
						//coordinates: decodePolyline(activity.map.summary_polyline).map(function (elt) { return [elt[1], elt[0]] })
						coordinates: decodePolyline(activity.map.summary_polyline).map(function (elt) { return [elt[1], elt[0]] })
					}
				};
				featureCollection.features.push(feature);
			}
		});


		var projection = d3.geoMercator().fitExtent([[this.props.poster.layout.margin, this.props.poster.layout.margin], [this.props.poster.layout.width - this.props.poster.layout.margin, this.props.poster.layout.height - this.props.poster.layout.margin - this.props.poster.legend.height - this.props.poster.legend.spacer - this.props.offset]], featureCollection);
		var path = this.path = d3.geoPath()
		.projection(projection);
		var tile = d3Tile.tile().size([this.props.poster.layout.width, this.props.poster.layout.height]);
		//tile.tileSize([512]);
		//tile.extent([[5.2894,48.50915],[5.40777,48.46927]]);
		var tiles = tile.scale(projection.scale() * 2 * Math.PI)
			.translate(projection([0, 0]))();

		var roadsLayer = d3.select('#roads');//this.roadsLayer;
		var buildingsLayer = d3.select('#buildings');//this.buildingsLayer;
		//var landuseLayer = this.landuseLayer;
		var waterLayer = d3.select('#water');//this.waterLayer;
		//console.log(tile());


		//MAPBOX
		tiles.forEach(function (elt, index) {

			let gm = new GlobalMercator();
			let result = null;
			result = gm.TileBounds(elt.x, elt.y, elt.z);
			let min = gm.MetersToLatLon(result.minx, result.miny);
			let max = gm.MetersToLatLon(result.maxx, result.maxy);
			let latBuffer = (max.lat - min.lat) * 0.01
			let lonBuffer = (max.lon - min.lon) * 0.01;
			min = { lat: min.lat - latBuffer, lon: min.lon - lonBuffer };
			max = { lat: max.lat + latBuffer, lon: max.lon + lonBuffer };

			var clipFeature = {
				"type": "Feature",
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[[min.lon, -min.lat], [max.lon, -min.lat], [max.lon, -max.lat],
						[min.lon, -max.lat], [min.lon, -min.lat]]
					]
				},
				"properties": {
					"name": "clip" + index,
				}
			}
			waterLayer.append('clipPath')
				.attr("id", "clip" + index)
				.append('path')
				.datum(clipFeature)
				.attr('d', path)

			fetch('https://api.mapbox.com/v4/mapbox.mapbox-terrain-v2,mapbox.mapbox-streets-v7/' + elt.z + '/' + elt.x + '/' + elt.y + '.mvt?style=mapbox://styles/mapbox/streets-v10@00&access_token=pk.eyJ1IjoiYWRlbGlzZSIsImEiOiJjamMwaTVzc2MzajQxMnZtd3hoOXh1ZTFsIn0.1XhKONmgz-Ra8O1nm_oqTQ').then(function (response) {
				return response.arrayBuffer();
			}).then(function (buffer) {
				var vectorTile = new VectorTile(new Protobuf(buffer));

				var data = {};
				for (var key in vectorTile.layers) {
					var vectorTileLayer = vectorTile.layers[key];
					var featureCollection = {
						"type": "FeatureCollection",
						"features": []
					}
					for (var i = 0; i < vectorTileLayer.length; i++) {
						featureCollection.features.push(vectorTileLayer.feature(i).toGeoJSON(elt.x, elt.y, elt.z));
					}
					data[key] = featureCollection;
					if (key === "road") {
						//console.log(JSON.stringify(featureCollection))  
						featureCollection.features.forEach(function (elt) {
							//console.log(elt.properties.type);
							//Remove points otherwise they are drawn as circle
							if (elt.geometry.type !== "Point" && elt.geometry.type !== "MultiPoint" && elt.properties.class!=='ferry') {
								roadsLayer.append('path')
									.datum(elt)
									.attr('d', path)
									.attr('class', 'roads')
									.style('stroke-linejoin', 'round');
							}

						})
					}
					if (key === "building") {

						featureCollection.features.forEach(function (elt) {
							if (elt.geometry.type !== "Point") {
								if (elt.geometry.type === "Polygon" || elt.geometry.type === "MultiPolygon") {
									buildingsLayer.append('path')
										.datum(elt)
										.attr('d', path)
										.attr('class', 'buildings')
											//.attr('vector-effect', 'non-scaling-stroke')
											/*.style('fill', '#666')
											.style('opacity', 1)
											.style('stroke', '#666')*/;
								} else {

								}
							}
						});
					}
					if (key === "water" || key === "waterway") {

						featureCollection.features.forEach(function (elt) {
							if (elt.geometry.type !== "Point") {
								if (elt.geometry.type === "Polygon" || elt.geometry.type === "MultiPolygon") {
									//waterLayer.append('path')

									waterLayer.append('path')
										.datum(elt)
										.attr('d', path)
										.attr('class', 'water')
										.attr("clip-path", "url(#clip" + index + ")")
										.style('stroke-linejoin', 'round')
											//.attr('vector-effect', 'non-scaling-stroke')
											/*.style('fill', '#aaa')
											.style('opacity', 1)
											.style('stroke', '#aaa')*/;
								} else {
									waterLayer.append('path')
										.datum(elt)
										.attr('d', path)
										.attr('class', 'waterway')
										.attr("clip-path", "url(#clip" + index + ")")
										.style('stroke-linejoin', 'round')
								}
							}
						});
					}
					/*if(key==="landuse" || key==="landuse_overlay"){
						
						featureCollection.features.forEach(function(elt){
							if(elt.geometry.type!="Point"){
								if(elt.geometry.type=="Polygon" || elt.geometry.type=="MultiPolygon" ){
									landuseLayer.append('path')
									.datum(elt)
										.attr('d', path)
										//.attr('vector-effect', 'non-scaling-stroke')
										.style('fill', '#FFF')
										.style('opacity', 1)
										.style('stroke', '#FFF');
								}else{
	
								}
							}
						});
					}
					if(key==="landcover"){
						
						featureCollection.features.forEach(function(elt){
							if(elt.geometry.type!="Point"){
								if(elt.geometry.type=="Polygon" || elt.geometry.type=="MultiPolygon" ){
									landuseLayer.append('path')
									.datum(elt)
										.attr('d', path)
										//.attr('vector-effect', 'non-scaling-stroke')
										.style('fill', '#FFF')
										.style('opacity', 1)
										.style('stroke', '#FFF');
								}else{
	
								}
							}
						});
					}*/
				}

				//console.log(vectorTile.layers.road.feature(3).toGeoJSON(1566,1171,12))
			});
		});


		
	}

	shouldComponentUpdate(nextProps) {
		if(this.props.activities.length!==nextProps.activities.length){
			this.display(nextProps.activities);
			return true
		}
		if(this.props.activities.length>0 && this.props.activities[0].id===nextProps.activities[0].id){
			return false
		}else{
			if(nextProps.activities.length>0){
				this.display(nextProps.activities);
			}
			
			return true
		}
	}
	
	render() {
		
		return (
				<g id='map' ref={(node) => this.container = node} />
		)
	}
}

export default Basemap;


// WEBPACK FOOTER //
// ./src/components/Basemap.js